module.exports = __webpack_public_path__ + "img/medical.92b6f228.svg";